import { useState, useEffect } from 'react';

export const Countdown = ({ start, onEnd }) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount(prevCount => Math.max(prevCount - 1, 0));
    }, 1000);

    if (count === 0) {
      onEnd();
    }

    return () => clearInterval(timer);
  }, [count]);
  return count;
};
